import * as model from './model';

export const userService = {
	...model,
};
